
import { getPostList } from '@/api/post';
import { Component, Vue } from 'vue-property-decorator';
import { IPost } from '@/types/post';

@Component({
})
export default class extends Vue {
  mounted() {
    this.getPostList();
  }

  private listLoading: boolean = true;

  private listQuery = {
    boardUid: '6369e1b3-560e-4141-8ecd-ce8bc3ac5d47',
    searchType: 'title',
    searchValue: '',
    page: 0,
    size: 10,
  };

  private postList: IPost[] = [];

  private totalElements: number = 0;

  private showUid = '';

  private getPostList() {
    this.listLoading = true;
    getPostList(this.listQuery).then((res) => {
      this.listLoading = false;
      const postList: any = [];
      res.data.content.forEach((post: any) => {
        postList.push({
          ...post,
          showStatus: false,
        });
      });
      this.postList = postList;
      this.totalElements = res.data.totalElements;
    });
  }

  private handleClickPost(post: any) {
    post.showStatus = !post.showStatus;
  }

  private baseUrl = process.env.VUE_APP_TARGET;
}
